import {ILoginService} from '../../auth/login.service';
import {IUser} from '../../api/api.types';
import {IUserApi} from '../../api/user-api.service';

export default class HomeController {
  static $inject = ['loginService', 'userApi', '$scope', '$window'];

  loggedIn:boolean;
  currentUser:IUser;

  constructor(private loginService:ILoginService,
              private userApi:IUserApi, $scope:ng.IScope,
              private $window: ng.IWindowService) {
    this.onLoginStateChange(loginService.isLoggedIn());
    const deregisterLoginStateListener = loginService
        .onLoginStateChange(loggedIn => this.onLoginStateChange(loggedIn));
    $scope.$on('$destroy', () => {
      deregisterLoginStateListener();
    });
  }

  logOut() {
    this.loginService.logOutUser();
    this.$window.localStorage.removeItem('currentOrgId');
  }

  private onLoginStateChange(loggedIn:boolean) {
    this.loggedIn = loggedIn;
    if (this.loggedIn) {
      this.currentUser = null;
      this.userApi.getCurrentUser().then(user => this.currentUser = user);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/home/home.controller.ts
 **/